import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import { useParams } from 'react-router-dom';

import SectionWrapper from '../../../message-response/components/section-wrapper/SectionWrapper';
import ChartsH2H from './components/h2h-charts/ChartsH2H';
import ConceptH2HFilters from './components/h2h-filters/ConceptH2HFilters';
import useResonanceLoadingState from '../../../../hooks/useResonanceLoadingState';
import { useProject } from '../../../../../context/ProjectContext';

function ConceptH2H({ appliedFilters }) {
  const { t } = useTranslation('resonance');
  const { id: projectId } = useParams();
  const { actions } = useProject();

  const isH2HConceptsLoading = useResonanceLoadingState('isH2HConceptsLoading');

  const [selectedH2HConcepts, setSelectedH2HConcepts] = useState([]);
  const [isGlobalPercentage, setIsGlobalPercentage] = useState(false);

  const isGlobalPercentageEnabled = useMemo(() => !!appliedFilters.length, [appliedFilters]);

  useEffect(() => {
    if (!isGlobalPercentageEnabled) {
      setIsGlobalPercentage(false);
    }
  }, [isGlobalPercentageEnabled]);

  useEffect(() => {
    actions('getResonanceH2HConcepts', { projectId, audiences: appliedFilters });
  }, [appliedFilters, projectId, actions]);

  return (
    <SectionWrapper
      title={t('conceptsH2H')}
      alignTitleTop
      Filters={
        <ConceptH2HFilters
          selectedH2HConcepts={selectedH2HConcepts}
          setSelectedH2HConcepts={setSelectedH2HConcepts}
          isGlobalPercentage={isGlobalPercentage}
          onChangeGlobalPercentage={setIsGlobalPercentage}
          isGlobalPercentageEnabled={isGlobalPercentageEnabled}
          isLoading={isH2HConceptsLoading}
        />
      }>
      {isH2HConceptsLoading ? (
        <Skeleton animation='wave' variant='rounded' height={350} />
      ) : (
        <ChartsH2H
          selectedH2HConcepts={selectedH2HConcepts}
          appliedFilters={appliedFilters}
          isGlobalPercentage={isGlobalPercentage}
        />
      )}
    </SectionWrapper>
  );
}

export default ConceptH2H;
